export const SERVICE_BASE_URL = ENV_SERVICE_BASE_URL;
export const WEBPAY_PAYMENT_URL = ENV_WEBPAY_PAYMENT_URL;
export const QTB_BASE_URL = ENV_QTB_BASE_URL;
export const WEBPAY_PAYMENT_URL_ZIB = ENV_WEBPAY_PAYMENT_URL_ZIB;

export const SECURE_STORAGE_SECRET = 'storage-secret-key';
export const SECURE_STORAGE_KEY_PREFIX = 'QBS_';
